@if (maxLength) {
  <span #charIndicator hidden class="char_indicator"
    >{{ _valueLength }}/{{ maxLength }}</span
  >
}
